import type { InjectionKey } from 'vue';

export interface ISideBarMenuOpenInjectedProps {
  setNewValue: (value: boolean) => void;
}

export const SIDEBAR_MENU_OPEN_INJECT_KEY = Symbol(
  'SIDEBAR_MENU_OPEN_INJECT_KEY'
) as InjectionKey<ISideBarMenuOpenInjectedProps>;
